import {Box} from '@vio/atlas/helpers/Box'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'

export const MAX_CTA_WIDTH_DESKTOP = 256

type Props = {
  detailsSlot: React.ReactNode
  priceSlot: React.ReactNode
  isVerticalLayout: boolean
}

export const RoomOfferLayout = ({
  detailsSlot,
  priceSlot,
  isVerticalLayout
}: Props) => {
  const {isMobile} = useDeviceLayout()
  return (
    <Box
      display="flex"
      flexDirection={isVerticalLayout ? 'column' : 'row'}
      alignItems="flex-start"
      justifyContent="space-between"
      gap={isMobile ? 's200' : 's600'}
      height="100%"
    >
      <Box
        alignSelf="stretch"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        width="100%"
      >
        {detailsSlot}
      </Box>
      <Box
        maxWidth={isVerticalLayout ? '100%' : `${MAX_CTA_WIDTH_DESKTOP}px`}
        width="100%"
        alignSelf="flex-end"
      >
        {priceSlot}
      </Box>
    </Box>
  )
}
